export function displayRequestErrors(errors, toaster) {
    let messages = [];
    if (typeof (errors) === 'string') {
        messages.push(errors)
    } else {
        messages.push(`Error: ${errors?.message}`)
    }
    return messages.map(el => toaster(el))
}